<template>
  <div class="dashboard_summary">
    <div class="dashboard_summary__inner">
      <div class="dashboard_summary__focus_info">
        <h2 class="dashboard_summary__headline">{{ $t('kpi.congratulations') }}</h2>
        <i18n class="dashboard_summary__headline" :path="pppFocus.headlineId" tag="h3">
          <template v-slot:companyName>{{ company_name }}</template>
          <template #focus>
            <b :class="`typo_hl_${pppFocus.id}`">{{ $t(pppFocus.headlineFocusId) }}</b>
          </template>
        </i18n>
        <p class="dashboard_summary__focus_info-copy">
          {{ $t(pppFocus.copyId) }}
          <br />
          <strong>
            {{ $t('kpi.findBalance') }}
            <br />
            <!-- eslint-disable @intlify/vue-i18n/no-raw-text -->
            <span v-t="'kpi.people.name'" class="typo_hl_people" />,
            <span v-t="'kpi.planet.name'" class="typo_hl_planet" />,
            <span v-t="'kpi.profit.name'" class="typo_hl_profit" />
            <!-- eslint-enable @intlify/vue-i18n/no-raw-text -->
          </strong>
        </p>
      </div>

      <div class="dashboard_summary__infos">
        <div class="dashboard_summary__info">
          <i18n
            path="kpi.yourCompanyValue.old"
            tag="h2"
            class="dashboard_summary__headline dashboard_summary__info-headline"
          >
            <template #companyValue>
              <b>{{ $t('kpi.yourCompanyValue.companyValue', { company_name }) }}</b>
            </template>
          </i18n>
          <div class="dashboard_summary__company_info">
            <CompanyValue
              :company-value="parseFloat(store.userModel.companyValue)"
              :average-company-value="parseFloat(store.companyAverageValue)"
            />
          </div>
        </div>
        <div class="dashboard_summary__info">
          <i18n path="kpi.yourFocus.your" tag="h2" class="dashboard_summary__headline">
            <template #focus>
              <b>{{ $t('kpi.yourFocus.focus') }}</b>
            </template>
          </i18n>
          <div class="dashboard_summary__company_info">
            <FocusDistribution
              :distribution="focusDistribution"
              :min-bar-height="20"
              :bar-height="80"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store, {
  getFocusDistribution,
  getPPPFocus,
  impactDistribution,
  getRadarChartData,
  getCompanyName,
} from '../../store';

import { playSound } from '../../services/sound';

import FocusDistribution from '../Chart/FocusDistribution';
import CompanyValue from '../CompanyValue';

export default {
  name: 'DashboardSummary',

  components: {
    FocusDistribution,
    CompanyValue,
  },

  data() {
    return {
      store,
      kpiData: getRadarChartData(),
    };
  },

  computed: {
    pppFocus: getPPPFocus,
    focusDistribution: getFocusDistribution,
    impactDistribution,
    company_name: getCompanyName,
  },

  mounted() {
    window.scrollTo(0, 0);
    playSound('fxA', 'headline');
  },
};
</script>

<style lang="scss" scoped>
.dashboard_summary {
  @include helper__greater($bp-2560) {
    // TODO: remove component inner margin
    margin-top: 20%;
  }
}

.dashboard_summary__headline {
  @include module-headline;
  margin-top: 5px;
}

.dashboard_summary__company_info {
  @include transparent-layer;
  margin-top: 10px;

  @include helper__greater($bp-1024) {
    height: 145px;
    margin-top: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
  }
}

.dashboard_summary__focus_info {
  margin-top: 40px;
  margin-bottom: 20px;
  padding: 20px;
  text-align: center;

  @include helper__greater($bp-1024) {
    margin-top: 130px;
  }
}

.dashboard_summary__focus_info .dashboard_summary__headline {
  @include helper__greater($bp-1024) {
    display: inline;
    padding-left: 2px;
    padding-right: 2px;
    font-size: 42px;
  }
}

.dashboard_summary__focus_info-copy {
  line-height: 22px;
  margin-top: 20px;
  margin-left: auto;
  margin-right: auto;
  max-width: 450px;

  @include helper__greater($bp-1024) {
    max-width: 470px;
  }
}

.dashboard_summary__infos {
  @include helper__greater($bp-1024) {
    text-align: center;
  }
}

.dashboard_summary__infos .dashboard_summary__headline {
  @include helper__greater($bp-1024) {
    font-size: 35px;
    margin-bottom: 20px;
    max-width: 100%;

    b {
      white-space: nowrap;
    }
  }
}

.dashboard_summary__info {
  @include helper__greater($bp-1024) {
    display: inline-grid;
    width: 385px;
  }

  & + & {
    margin-top: 20px;

    @include helper__greater($bp-1024) {
      margin-top: auto;
    }
  }
}
</style>
